import { apiUrl } from '../config/api'

export async function listSocietyComplianceDocuments(complianceSocietyId) {
  let params = {
    complianceSocietyId,
    brandLabel: window.$brand
  }

  let url = apiUrl('ListSocietyComplianceDocuments')
  return sendReq(params, url)
}

export async function listClientDocumentsForSociety(societyId) {
  let url = apiUrl('ListClientDocumentsForSociety')
  return sendReq({ societyId }, url)
}

export async function linkClientDocumentToCompliance({
  complianceSocietyId,
  clientDocumentId,
  loggedUserId
}) {
  const params = {
    complianceSocietyId,
    clientDocumentId,
    loggedUserId
  }

  let url = apiUrl('LinkClientDocumentToCompliance')

  return sendReq(params, url)
}

export async function unlinkSocietyComplianceDocument(id, loggedUserId) {
  const params = { id, loggedUserId }
  let url = apiUrl('UnlinkSocietyComplianceDocument')
  return sendReq(params, url)
}

export async function uploadSocietyComplianceDocument({
  file,
  societyLegalId,
  complianceSocietyId,
  complianceId,
  loggedUserId
}) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('societyLegalId', societyLegalId)
  formData.append('complianceSocietyId', complianceSocietyId)
  formData.append('complianceId', complianceId)
  formData.append('loggedUserId', loggedUserId)
  formData.append('brandLabel', window.$brand)

  let url = apiUrl('UploadSocietyComplianceDocument')

  try {
    let res = await fetch(url, {
      method: 'POST',
      body: formData
    }).catch((error) => console.log(error))

    if (!res) return null
    const text = await res.text()
    return text ? JSON.parse(text) : { status: res.status }
  } catch (err) {
    console.error('Upload error:', err)
    return null
  }
}

export async function deleteSocietyComplianceDocument(id, loggedUserId) {
  let params = {
    id: id,
    loggedUserId: loggedUserId,
    brandLabel: window.$brand
  }

  let url = apiUrl('DeleteSocietyComplianceDocument')
  return sendReq(params, url, true)
}

export async function generateSocietyComplianceDocumentUrl(id) {
  let url = apiUrl('GenerateSocietyComplianceDocumentUrl')
  const res = await fetch(`${url}&id=${id}`)
  return res.json()
}

async function sendReq(params, url, allowEmpty = false) {
  let res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params)
  }).catch((error) => console.log(error))

  if (!res) return null

  if (allowEmpty) {
    const text = await res.text()
    return text ? JSON.parse(text) : { status: res.status }
  }

  return res.json()
}
